export const reorderList = (items, itemId, direction, idField) => {
  const currentIndex = items.findIndex(
    (item) => item[idField] === itemId,
  );

  if (currentIndex < 0) {
    return items;
  }

  const targetIndex = {
    first: 0,
    last: items.length - 1,
    up: currentIndex - 1,
    down: currentIndex + 1,
  }[direction];

  if (
    targetIndex === undefined ||
    targetIndex < 0 ||
    targetIndex >= items.length ||
    targetIndex === currentIndex
  ) {
    return items;
  }

  const next = [...items];
  const [moved] = next.splice(currentIndex, 1);
  next.splice(targetIndex, 0, moved);
  return next;
};

export const reorderSliderList = (items, sliderId, direction) =>
  reorderList(items, sliderId, direction, "slider_id");
